import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/ui/table';

const AgenciesStatsTable = ({ stats }) => {
  if (!stats.length) return <p className="py-8 text-sm text-slate-500">Aucune société pour cette campagne.</p>;

  return (
    <Table
      containerClassName="max-h-[308px] overflow-y-auto"
      containerProps={{
        tabIndex: 0,
        'aria-label': 'Tableau des sociétés',
      }}
    >
      <TableHeader className="sticky top-0 z-10 bg-white">
        <TableRow>
          <TableHead>Société</TableHead>
          <TableHead>Soldés</TableHead>
          <TableHead>Acompte payé</TableHead>
          <TableHead>Aptes</TableHead>
          <TableHead>Passeports déposés</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {stats.map((row) => (
          <TableRow key={row.id}>
            <TableCell>{row.name}</TableCell>
            {['soldes', 'deposit_paid', 'medically_fit', 'passport_deposited'].map((field) => (
              <TableCell key={field}>{row[field].toLocaleString('fr-FR')}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default AgenciesStatsTable;
